__webpack_require__.p = "/react-corporate-website/";